import React from 'react';
import { AddLinkToolbarItem } from "../items/AddLinkToolbarItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function LinkTiptapItem({
  editor
}) {
  return /*#__PURE__*/_jsx(AddLinkToolbarItem, {
    onUpdateLink: ({
      href,
      name
    }) => {
      editor.chain().focus().setLink({
        href
      }).run();
    },
    onAddLink: ({
      href,
      name
    }) => {
      const {
        selection
      } = editor.view.state;
      editor.chain().focus().setLink({
        href
      })
      // this little maneuver ensures that the cursor is outside the link afterwards:
      // insert an extra space, select the space, unset the link from the space,
      // and delete the space
      .insertContent(`${name} `).setTextSelection({
        from: selection.from + name.length,
        to: selection.from + name.length + 1
      }).unsetLink().deleteSelection().run();
    },
    onRemoveLink: editor.commands.unsetLink,
    getHref: () => {
      const href = editor.getAttributes('link')?.href;
      return href?.replace(/^mailto:/u, '') ?? '';
    },
    getName: () => {
      const href = editor.getAttributes('link')?.href;
      const {
        selection,
        doc
      } = editor.view.state;
      if (selection.from === selection.to && href !== undefined) {
        const resolvedPos = doc.resolve(selection.from);
        const linkChild = resolvedPos.parent.content.child(resolvedPos.index());
        return linkChild.text ?? '';
      }
      return editor.state.doc.textBetween(selection.from, selection.to, '');
    },
    action: () => console.log('addLink'),
    on: editor.isActive('link')
  });
}